import type { SVGProps } from 'react';

export const ExclamationmarkTriangleFillSFSymbolMedium = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 21.0023 18.7605"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="18.7605" opacity="0" width="21.0023" x="0" y="0" />{' '}
        <path
          d="M12.6943 1.39238L20.2531 14.5709C20.506 15.0164 20.641 15.509 20.641 15.982C20.641 17.5166 19.5736 18.741 17.8695 18.741L2.77324 18.741C1.06738 18.741 0 17.5166 0 15.982C0 15.509 0.120703 15.0244 0.38789 14.5727L7.94668 1.39238C8.46582 0.468554 9.38515 0 10.3223 0C11.2576 0 12.1637 0.465038 12.6943 1.39238ZM9.13281 14.3018C9.13281 14.9377 9.67754 15.417 10.332 15.417C10.9785 15.417 11.5197 14.9457 11.5197 14.3018C11.5197 13.6533 10.9883 13.1803 10.332 13.1803C9.66953 13.1803 9.13281 13.6596 9.13281 14.3018ZM9.27774 6.22811L9.41524 11.1469C9.43379 11.726 9.75918 12.0523 10.332 12.0523C10.8791 12.0523 11.2027 11.734 11.2213 11.1434L11.3748 6.23612C11.3934 5.63944 10.9375 5.21288 10.3223 5.21288C9.69102 5.21288 9.25918 5.63144 9.27774 6.22811Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
